import { d as debounce } from "./utilities.js";
import "./lodash-utils.js";
class ShopifyFiltering extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.form = this.querySelector("form");
    this.inputs = this.querySelectorAll("input");
    this.loadingSpinners = this.querySelectorAll(".loading__spinner");
    this.filterData = [];
    this.clearButton = this.querySelector(".clear-filters");
    this.customFilters = this.querySelectorAll(
      ".shopify-filter__custom-filter"
    );
    this.productGridSelectorId = "product-grid__products";
    this.productGrid = document.getElementById(this.productGridSelectorId);
    console.log(this.productGridSelectorId, this.productGrid);
    if (this.clearButton) {
      this.clearButton.addEventListener("click", this.clearFilters.bind(this));
    }
    this.form.addEventListener("input", this.debouncedOnSubmit.bind(this));
    this.customFilters.forEach((filter) => {
      const queryValue = filter.value.replace(" ", "+");
      if (window.location.search.includes(queryValue)) {
        filter.checked = true;
      }
    });
    this.handleInitialStatus();
  }
  handleInitialStatus() {
    this.inputs.forEach((input) => {
      if (input.checked) {
        this.handleAllFilterUpdate(input);
      }
    });
  }
  clearFilters(event) {
    this.form.reset();
    this.onSubmitForm("", event);
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  onSubmitForm(searchParams, event) {
    this.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    this.handleAllFilterUpdate(event);
    this.createSearchParams(this.form);
    this.onSubmitForm(this.createSearchParams(this.form), event);
  }
  handleAllFilterUpdate(event) {
    let el = null;
    if (event.target) {
      el = event.target;
    } else {
      el = event;
    }
    const targetName = el.name;
    const targetValue = el.value;
    const targetChecked = el.checked;
    if (el.type == "checkbox" || el.type == "radio") {
      document.querySelectorAll(`input[name="${targetName}"][value="${targetValue}"]`).forEach((input) => {
        if (input != el) {
          input.checked = targetChecked;
        }
      });
    }
    if (el.dataset.scent) {
      const scent = el.dataset.scent;
      const currentScent = this.productGrid.dataset.scent;
      if (!currentScent) {
        this.productGrid.dataset.scent = "";
      }
      console.log(scent, currentScent);
      if (!currentScent.includes(scent) && el.checked) {
        this.productGrid.dataset.scent = `${currentScent} ${scent},`;
      } else {
        this.productGrid.dataset.scent = currentScent.replace(`${scent},`, "");
      }
    }
    if (el.dataset.size) {
      const size = el.dataset.size;
      const currentSize = this.productGrid.dataset.size;
      if (!currentSize) {
        this.productGrid.dataset.size = "";
      }
      if (!currentSize.includes(size) && el.checked) {
        this.productGrid.dataset.size = `${currentSize} ${size},`;
      } else {
        this.productGrid.dataset.size = currentSize.replace(`${size},`, "");
      }
    }
    this.updateVisibleProducts();
  }
  updateVisibleProducts() {
    this.productGrid.querySelectorAll(`.card--product`).forEach((card) => {
      const cardElement = card;
      const cardScent = cardElement.dataset.scent || "";
      const cardSize = cardElement.dataset.size || "";
      const currentScent = this.productGrid.dataset.scent || "";
      const currentSize = this.productGrid.dataset.size || "";
      const noScentFilter = currentScent.trim() === "";
      const noSizeFilter = currentSize.trim() === "";
      const matchesScent = noScentFilter || currentScent.includes(cardScent);
      const matchesSize = noSizeFilter || currentSize.includes(cardSize);
      if (matchesScent && matchesSize) {
        cardElement.classList.remove("hidden");
      } else {
        cardElement.classList.add("hidden");
      }
    });
  }
  getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id
      }
    ];
  }
  renderPage(searchParams, event, updateURLHash = true) {
    this.searchParamsPrev = searchParams;
    const renderSections = this.getSections();
    const countContainer = document.getElementById("ProductCount");
    this.loadingSpinners.forEach(
      (spinner) => spinner.classList.remove("hidden")
    );
    document.getElementById("ProductGridContainer").classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    renderSections.forEach((section) => {
      console.log(section);
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      this.filterData.some(filterDataUrl) ? this.renderSectionFromCache(filterDataUrl, event) : this.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) this.updateURLHash(searchParams);
  }
  renderSectionFromFetch(url, event) {
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      this.filterData = [...this.filterData, { html, url }];
      this.renderProductGridContainer(html);
      this.updateVisibleProducts();
    });
  }
  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderProductGridContainer(html);
    this.updateVisibleProducts();
  }
  renderProductGridContainer(html) {
    console.log(this.productGrid, this.productGridSelectorId);
    console.log("HTMl", html);
    document.getElementById(this.productGridSelectorId).innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById(this.productGridSelectorId).innerHTML;
    document.getElementById("ProductGridContainer").classList.remove("loading");
  }
}
if (!customElements.get("shopify-filtering")) {
  customElements.define("shopify-filtering", ShopifyFiltering);
}
export {
  ShopifyFiltering,
  ShopifyFiltering as default
};
